import axios from "axios"
import { API_URL, getHeaders } from "../config"

export const postVideoHistory = (module, time, videoTime, totalTime, videoId) => {
    return axios.post(API_URL + "/api/video/report/create", 
        { module, time, videoTime, totalTime, videoId }, 
        { headers: getHeaders().headers });
}